import { LoadDescriptionT } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { AppDispatch, AppState } from 'bootstrap.store';
import { actions as personalActions } from 'components/settings/actions/personal';
import { userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { presenceActions } from '../actions/presenceActions';
import PresenceOverlay from '../components/PresenceOverlay';

const { presenceSetOthersSimultaneousRinging } = presenceActions;

const hasActivePhoneConversation = (
  loadDescriptions: LoadDescriptionT[],
): boolean =>
  loadDescriptions.some(
    (o) =>
      (o.conversation_channel === 'pstnphone' ||
        o.conversation_channel === 'callback') &&
      o.load_type !== 'acw' &&
      o.load_type !== 'nonlive',
  );

const mapStateToProps = (state: AppState) => {
  const isSimultaneousRingLoading =
    state.presence.meta.toggleSimultaneousRing === 'loading';

  const canMakeInternalCall =
    !state.telephony.isMicrophoneBlocked &&
    !hasActivePhoneConversation(
      state.presence.presence.presence_status.load_descriptions,
    );

  return {
    isSimultaneousRingLoading,
    canMakeInternalCall,
    favorites: new Set<string>(state.settings.personal.favouriteTeamMemberIds),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    internalCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeInternalCall,
    ),
    showUserModal: (payload: { user: Partial<User> }) =>
      dispatch(userModalActions.show(payload)),
    presenceSetOthersSimultaneousRinging: bindActionToPromise(
      dispatch,
      presenceSetOthersSimultaneousRinging,
    ),
    personalAddToFavouriteTeamMemberIds: bindActionToPromise(
      dispatch,
      personalActions.personalAddToFavouriteTeamMemberIds,
    ),
    personalRemoveFromFavouriteTeamMemberIds: bindActionToPromise(
      dispatch,
      personalActions.personalRemoveFromFavouriteTeamMemberIds,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresenceOverlay);
